// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"1c518961","176":"51c81271","191":"7a12d3cb","467":"9f731079","595":"58b6bb6a","667":"a9d07cef","787":"4b7a54ae"}[chunkId] + ".chunk.js";
};